import(/* webpackMode: "eager" */ "/vercel/path0/src/app/appointments/page.tsx");
